import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_SPESA } from '../../data.const';
import {
  retrieveSpesaListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteSpesaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_SPESA),
    map(({ payload: { ids, ...rest } }: any) => ({
      body: {
        ids,
      },
      listBody: rest,
    })),
    // tap(p => console.log(`[epic ${DELETE_SPESA}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        defer(() =>
          from(
            request({
              path: `spesa`,
              method: httpMethods.DELETE,
              body,
            })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_SPESA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveSpesaListAction(listBody))),
            catchError((err) => {
              console.error(`[epic ${DELETE_SPESA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default deleteSpesaEpic;
